module.exports = __webpack_public_path__ + "static/img/14000756.926211a3.png";